import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { GlobalStateContext } from "../GlobalStates";
import { isAuthenticated } from "../../helperData/panelRoutes";
import SidebarMenu from "../sidebarMenu";

const MainPanel = () => {
    const { auth } = useContext(GlobalStateContext);
    const location = useLocation();

    if (!isAuthenticated(auth)) {
        return (
            <Navigate
                to="/auth"
                replace
                state={{ from: `${location.pathname}${location.search}` }}
            />
        );
    }

    return (
        <div className="app_content">
            <SidebarMenu />
            <div className="main_panel">
                <Outlet />
            </div>
        </div>
    );
};

export default MainPanel;
